export interface ISimMapping {
    Id?: number;
    SimId?: number;
    Serial: string;
    EndUtc?: Date | string;
    StartUtc?: Date | string;
    SimMappingType?: SimMappingType
}

export enum SimMappingType {
    Unit,
    Peripheral
}
